import {
  GET_SCHEMAS,
  GET_ASSETS_SCHEMAS,
  GET_CONTRACT_SCHEMAS,
  GET_EPC_SCHEMAS,
  SET_SCHEMAS_TEMPLATES,
  SAVE_NAME,
  ADD_SCHEMA,
  GET_SCHEMA_BY_ID,
  EMPTY_SCHEMA_TEMPLATE,
  EDIT_SCHEMA
} from "./../actions/types";


export default function(state = {}, action) {
  switch (action.type) {
    case GET_SCHEMAS:
      return { ...state, ...action.payload };
    case GET_SCHEMA_BY_ID:
      return { ...state, schema: action.payload };
    case EMPTY_SCHEMA_TEMPLATE:
      return { ...state, schema: null };
    case GET_ASSETS_SCHEMAS:
      return { ...state, ...action.payload };
    case GET_CONTRACT_SCHEMAS:
      return { ...state, ...action.payload };
    case GET_EPC_SCHEMAS:
      return { ...state, ...action.payload };
    case SET_SCHEMAS_TEMPLATES:
      return { ...state, schemasTemplates: action.payload };
    case ADD_SCHEMA:
      return { ...state, user_schema: action.payload };
    case EDIT_SCHEMA:
      return { ...state, user_schema: action.payload };
    case SAVE_NAME:
      return { name: action.payload };

    //   case RESET_PASSWORD_USER:
    //     return { ...state, response: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/schemas.js